import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'anterasoftware-kanban-add-edit-swimlane',
  templateUrl: './kanban-add-edit-swimlane.component.html',
  styleUrls: ['./kanban-add-edit-swimlane.component.scss']
})
export class KanbanAddEditSwimLaneComponent implements OnInit {

  // TODO: change component name to have dialog in it.
  constructor(private fb: FormBuilder, public dialogRef: MatDialogRef<KanbanAddEditSwimLaneComponent>, @Inject(MAT_DIALOG_DATA) public data:any ) { }

  public editFlag = false;
  public positionList: any[] = [];
  public hoursList = [
    { label:'1 hour',  value: 1},
    { label:'8 hours',  value: 8},
    { label:'12 hours',  value: 12},
    { label:'24 hours',  value: 24},
    { label:'3 days',  value: 72},
    { label:'7 days',  value: 168},
    { label:'15 days',  value: 360},
    { label:'30 days',  value: 720},
  ]

  public swimLaneForm = this.fb.group({
    label: [''],
    position: [0],
    dropOff: [''],
    dropOffHour: ['']
  })

  ngOnInit(): void {
    this.editFlag = this.data.panel ? true : false;
    if(this.editFlag) {
      if(this.data.swimlaneLength) {
        for(let i = 0; i < this.data.swimlaneLength; i++) {
          this.positionList.push(i+1);
        }
      }    
    } else {
      if(this.data.swimlaneLength) {
        for(let i = 0; i <= this.data.swimlaneLength; i++) {
          this.positionList.push(i+1);
        }
      }
    }
    //this.positionList = this.data.positionList;

    this.setFormValues();
  }

  /**
   * Sets the form values that already exist.
   *
   * @returns {void}
   */
  public setFormValues(): void{
    let dropOff = false;
    if(this.data?.panel?.header?.dropOffHour > 0) {
      dropOff = true;
    } else {
      dropOff = false;
    }
    const values = {
      label: this.data?.panel?.header?.title || '',
      position: this.data?.panel?.header?.position || 0,
      dropOff: dropOff || '',
      dropOffHour: this.data?.panel?.header?.dropOffHour > 0 ? this.data?.panel?.header?.dropOffHour : 1 
      || 1,
    };

    this.swimLaneForm.setValue(values);
  }


  /**
   * Saves the form and closes the dialog.
   *
   * @returns {void}
   */
  public onSave(): void {
    const formValues = this.swimLaneForm.getRawValue();

    formValues.id = this.data?.panel?.id;
    this.dialogRef.close(formValues);
  }

  /**
   * Closes the dialog on click of cancel.
   *
   * @returns {void}
   */
  public onClose(): void{
    this.dialogRef.close();
  }
}
